import { text } from '@fortawesome/fontawesome-svg-core';
import React, { useState } from 'react'
import './Carouselvideo.css'
import Carousel from "react-multi-carousel"
import 'react-multi-carousel/lib/styles.css'
import img1 from "../../assets/video/img-1.png"
import img2 from "../../assets/video/img-2.png"
import img3 from "../../assets/video/img-3.png"
import img4 from "../../assets/video/img-4.png"
import img5 from "../../assets/video/image-5.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
library.add(fas)

const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 4 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 3,
      slidesToSlide: 3 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 767, min: 464 },
      items: 2,
      slidesToSlide: 1 // optional, default to 1.
    }
  };
  const sliderImageUrl = [
    //First image url
    {
        url:img1,
        src:'https://www.youtube.com/embed/vhMYlUAzIM4',
        caption: 'Physical Design Sample Class'
    },
    {
        url:img2,
        src:'https://www.youtube.com/embed/1rNQoSFiOSg',
        caption: 'Analog Layout Design Sample Class'
    },
    {
        url:img3,
        src:'https://www.youtube.com/embed/Ei5rhB9uFSc',
        caption: 'ASIC Verification Sample Class'
    },
    {
        url:img4,
        src:'https://www.youtube.com/embed/XVQ7wdhktB4',
        caption: 'Analog Circuit Design Sample Class'
    },
    {
        url:img5,
        src:'https://www.youtube.com/embed/EMVQbVhoS2A',
        caption: 'Design For Test Sample Class'
    },
    
   
  ];


const Carouselvideo = () => {
    const [isOpen, setIsOpen] = useState(false);
  const [iframeUrl, setIframeUrl] = useState("");

  const openPopup = (url) => {
    setIframeUrl(url);
    setIsOpen(true);
  };

  const closePopup = () => {
    setIsOpen(false);
    setIframeUrl("");
  };
  return (
    <div class="course-video mb-5">
    
    <div className="carouselvideo">
        <Carousel
        responsive={responsive}
        autoPlay={true}
        swipeable={true}
        draggable={true}
        showDots={true}
        infinite={true}
        partialVisible={false}
        arrows={false}
        dotListClass="custom-dot-list-style"
      >
        {sliderImageUrl.map((imageUrl, index) => {
          return (
            <div className="slider" key={index}>
              <div class="video-box">
                <img src={imageUrl.url} alt="movie" />
                <div class="video-play-btn">
                    <FontAwesomeIcon
                    icon="fa-solid fa-circle-play"
                    className="play-icon"
                    onClick={() => openPopup(imageUrl.src)}
                  />
                </div>
              </div>
              <h3>{imageUrl.caption}</h3>

            </div>
            
          );
        })}
      </Carousel>
    </div>
    {isOpen && (
        <div className="popup-overlay">
          <div className="popup-content">
            <button className="close-btn" onClick={closePopup}>
              &times;
            </button>
            <iframe
              src={iframeUrl}
              title="Popup Iframe"
              width="600"
              height="400"
              style={{ border: "none" }}
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </div>
  )
}

export default Carouselvideo